import { useEffect, useState } from "react";
import { adminApi } from "./api";

const ITEMS = [
  { key: "partner_logos", title: "Publishable partner names + logo permission" },
  { key: "company_credentials", title: "Approved company credentials (licence / registration)" },
  { key: "case_study", title: "Approved case study or reference" },
  { key: "countries_served", title: "Countries currently served" },
  { key: "leadership_bio", title: "Ken's biography and approved leadership message" },
];

export default function Evidence() {
  const [state, setState] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    adminApi.getEvidence().then((r) => setState(r.data || {}));
  }, []);

  const toggle = (key, field) => (e) => {
    const next = { ...(state[key] || {}), [field]: e.target.checked };
    setState({ ...state, [key]: next });
  };
  const noteChange = (key) => (e) => {
    const next = { ...(state[key] || {}), note: e.target.value };
    setState({ ...state, [key]: next });
  };

  const save = async () => {
    setSaving(true); setMsg("");
    try {
      await adminApi.putEvidence(state);
      setMsg("Saved.");
      setTimeout(() => setMsg(""), 2000);
    } catch { setMsg("Save failed."); }
    finally { setSaving(false); }
  };

  return (
    <div className="ga-page" data-testid="evidence-page">
      <div className="ga-eyebrow">Owner tools</div>
      <h1 className="ga-title">Evidence awaiting approval</h1>
      <p className="ga-mute" style={{ maxWidth: "60ch" }}>
        Private checklist. Nothing here renders on the public site until you manually publish the
        underlying content via the Content editor.
      </p>

      <div className="ga-info-card" style={{ padding: 0 }}>
        {ITEMS.map((it) => {
          const s = state[it.key] || {};
          const ready = s.received && s.approved;
          return (
            <div key={it.key} className="ga-info-card__row ga-info-card__row--stack" data-testid={`evidence-${it.key}`}>
              <div>
                <div className="ga-info-card__value">{it.title}</div>
                {s.updated_at && (
                  <div className="ga-mute" style={{ fontSize: 12, marginTop: 4 }}>
                    Last update by {s.updated_by || "—"} · {new Date(s.updated_at).toLocaleString()}
                  </div>
                )}
                {ready && (
                  <span style={{ display: "inline-block", marginTop: 8, padding: "3px 8px", border: "1px solid var(--gp-gold)", color: "var(--gp-gold)", fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase" }} data-testid={`evidence-ready-${it.key}`}>
                    Ready to publish
                  </span>
                )}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <label className="ga-mute" style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <input type="checkbox" checked={!!s.received} onChange={toggle(it.key, "received")} data-testid={`evidence-received-${it.key}`} /> Received
                </label>
                <label className="ga-mute" style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <input type="checkbox" checked={!!s.approved} onChange={toggle(it.key, "approved")} data-testid={`evidence-approved-${it.key}`} /> Approved for publication
                </label>
                <textarea rows={2} placeholder="Notes" value={s.note || ""} onChange={noteChange(it.key)} data-testid={`evidence-note-${it.key}`} style={{ padding: 8, background: "var(--gp-navy)", color: "var(--gp-white)", border: "1px solid var(--gp-line-dark)", fontFamily: "inherit", fontSize: 13 }} />
              </div>
            </div>
          );
        })}
      </div>

      <div className="ga-savebar">
        <div>{msg && <span className="ga-saved" data-testid="evidence-msg">{msg}</span>}</div>
        <button className="ga-btn" onClick={save} disabled={saving} data-testid="evidence-save">
          {saving ? "Saving…" : "Save checklist"}
        </button>
      </div>
    </div>
  );
}
